<template>
  <div class="clientsWrapper">
    <my-title>Accounts</my-title>

    <div class="columns">
      <div class="column has-text-right">
        <button
          class="button mr-3"
          @click="download"
        >
          <span class="icon">
            <i
              class="fas"
              :class="building ? 'fa-circle-notch fa-spin' : 'fa-download'"
            ></i>
          </span>
        </button>

        <create-button
          caption="Nieuwe klant"
          @click="createItem"
        ></create-button>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- TODO: Move this to a modal -->
        <items
          :items="items"
          :parentId="null"
          :opened="true"
        ></items>

        <item-edit :items="items"></item-edit>
      </div>
    </div>

    <select-user></select-user>

    <select-bundle></select-bundle>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import Items from '@/components/items/Items'
import MyTitle from '@/components/modules/Title'
import ItemEdit from '@/components/items/ItemEdit'
import SelectUser from '@/components/users/SelectUser'
import CreateButton from '@/components/modules/CreateButton'
import SelectBundle from '@/components/bundles/SelectBundle'

export default {
  components: {
    Items,
    MyTitle,
    ItemEdit,
    SelectUser,
    CreateButton,
    SelectBundle
  },

  data () {
    return {
      search: null,
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      item: 'items/item',
      items: 'items/items',
      building: 'items/building'
    })
  },

  methods: {
    createItem () {
      this.$store.commit('items/RESET')
      bus.$emit('createItem', { parentId: null })
    },

    download () {
      this.$store.commit('SET_BUILDING', true)

      this.$store.dispatch('items/download')
    }
  }
}
</script>

<style scoped>
  .toggle {
    position: absolute;
    right: 0;
  }
  li > ul {
    margin-left: 30px;
  }
</style>
